import { useInputTextProps } from '../../hooks'
import * as Comp from './input-label.styles'

export const InputTextLabel = ({ children }: { children: React.ReactNode }) => {
  const { disabled, readonly, size } = useInputTextProps()
  return (
    <Comp.Label
      numberOfLines={1}
      disabled={disabled}
      readonly={readonly}
      size={size}
    >
      {children}
    </Comp.Label>
  )
}
